/*----------------------------------
  JavaScript
------------------------------------*/
// 100vhをiOSでも正しく表示させるためのハック
const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);
setFillHeight();

// 画面幅が374px以下のときviewportを375pxに固定するためのハック
const viewport = document.querySelector('meta[name="viewport"]');
const switchViewport = () => {
  const value =
    window.outerWidth > 374
      ? "width=device-width,initial-scale=1"
      : "width=375";
  if (viewport.getAttribute("content") !== value) {
    viewport.setAttribute("content", value);
  }
};
window.addEventListener("resize", switchViewport);
switchViewport();

/*----------------------------------
  jQuery
------------------------------------*/
jQuery(function ($) {
  /*----------------------------------
    ハンバーガーメニュー
  ------------------------------------*/
  $("html").removeClass("js-scroll-prevent");
  $("#js-hamburger-button").click(function () {
    $("html").toggleClass("js-scroll-prevent");
    $("body").toggleClass("js-is-hamburger-active");

    if ($(this).attr("aria-expanded") === "false") {
      $(this).attr("aria-expanded", true);
      $(this).attr("aria-label", "メニューを閉じる場合はこちら");
    } else {
      $(this).attr("aria-expanded", false);
      $(this).attr("aria-label", "メニューを開く場合はこちら");
    }
  });
});
